import React, { useState } from "react";
import { Link } from "react-router-dom";
import intermediate_track from "../images/entrylevel2.png";
import "../styles/BeginnersTrack.css";
import { motion } from "framer-motion";
import useRegistrationStatus from "../hooks/useRegistrationStatus";
import back from "../images/back.png";
import sogo from "../images/image1.png";
import toba from "../images/image2.png";
import eri from "../images/image3.png";

function IntermediateTrack() {
  const { registrationData } = useRegistrationStatus();

  const data = [
    {
      question: "Generic Training (Weeks 1-6)",
      answer:
        "Week 1: Regex + Unit Testing for AI Pipelines. Week 2: Data Wrangling (Team tasks, AI-based data cleaning and exploration). Weeks 3-4: Tool-Specific Training (Python, SQL, Docker, Polars, AWS) - Intro to integrating AI tools for faster data handling and SQL optimization with tools like AI-driven SQL advisors. Week 5: Backend Development - Flask serverless solutions with AI-based API services, CI/CD with AI-enhanced automation workflows. Week 6: Linux for Data Professionals, Cloud technologies and AI cloud services (AWS SageMaker, AI pipeline tools).",
      buttons: [{ text: "Resources", to: "/page1" }],
    },
    {
      question: "Data Engineering Specialization (Weeks 7-14)",
      answer:
        "Week 7-8: Understanding ETL/ELT - Include AI automation for ETL processes using tools like Prefect or Airflow with ML integration. Week 9-10: DBMS + Data Modeling for AI data structures. Weeks 11-14: Big Data, Data Lakes, and Warehouses - AI-powered metadata management and indexing solutions.",
      buttons: [{ text: "Resources", to: "/page2" }],
    },
    {
      question: "Machine Learning Specialization (Weeks 7-14)",
      answer:
        "Weeks 7-10: Data Wrangling, EDA (Exploratory Data Analysis), Feature Engineering. Weeks 11-12: Model Training and Evaluation (focus on automated hyperparameter tuning using libraries like AutoML). Weeks 13-14: Model Deployment and Serving - Include API-based model-serving solutions using ML platforms.",
      buttons: [{ text: "Resources", to: "/page3" }],
    },
    {
      question: "AI & LLM Integration Specializations",
      answer:
        "NLP Specialization: Traditional NLP (Tokenization, Vectorization, Text Summarization) and Advanced NLP (Use LLMs like GPT, BERT for complex tasks, Transformers, Fine-tuning, and Prompt Engineering). Build NLP projects using RAG pipelines, document summarizers, and language classifiers using LangChain, LLamaIndex, or Hugging Face. Computer Vision: Basics of Image Processing (Pillow, OpenCV), AI-powered applications like image recognition, text detection, and face analysis. Data Analysis: Data Visualization (Matplotlib, Seaborn, Plotly), AI for storytelling and automated dashboard creation.",
      buttons: [{ text: "Resources", to: "/page4" }],
    },
    {
      question: "Collaboration Phase (2 Months)",
      answer:
        "Collaborative projects integrating Data Engineering, ML Engineering, and Data Analysis. Examples: Build a full-stack pipeline that extracts, analyzes, and visualizes real-world data using LLMs and AI APIs. AI-supported documentation, project tracking, and reporting.",
      buttons: [{ text: "Resources", to: "/page5" }],
    },
  ];

  return (
    <div className="beginner_wrapper">
      <div className="beginner-container">
        <div className="beginner-content" id="intermediate-content">
          <div className="back_home">
            <Link
              className="scrolllink"
              to="/#beginnersPage"
              id="scroll_display"
            >
              <img src={back} alt="goback" className="goback" />
              
            </Link>
          </div>

          <h1>
            Intermediate <span className="orange"> Modules</span>
          </h1>
          <motion.p
            id="intermediate_para"
            initial={{ opacity: 0, scale: 0.5 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1 }}
          >
            Already familiar with the basics? The Intermediate Track is your
            pathway to elevating your data mastery to new heights. Perfect for
            those with some experience in data, this track is designed to refine
            your skills and prepare you for more complex challenges.
          </motion.p>

          {!registrationData?.is_open && (
            <div className="button">
              <Link to="/FormInput" className="reserve-btns">
                <button>Join the Waitlist</button>
              </Link>
            </div>
          )}
        </div>
        {/* </div> */}

        <div className="faq_mentors_text">
          <h1>
            Track <span className="oranges">Modules</span>
          </h1>
        </div>

        <div className="modules-grid-container">
          <div className="modules-grid">
            {data.map((item, i) => (
              <div className="module-card" key={i}>
                <div className="module-header">
                  <h3>{item.question}</h3>
                </div>
                <div className="module-content">
                  <p>{item.answer}</p>
                </div>
                <div className="module-buttons">
                  {item.buttons.map((button, index) => (
                    <Link key={index} to={button.to} className="module-btn">
                      {button.text}
                    </Link>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="mentors">
          <div className="beginners_mentors_text">
            <h1>
              Meet your <span className="oranges"> Instructors </span>
            </h1>
            <p>These are your instructor for the next couple of weeks</p>
          </div>

          <div className="beginners_mentors_container">
            <div className="beginners_mentor_wraps">
              <div className="mentor_image_wrap">
                <img
                  src={sogo}
                  alt="Sogo"
                  className="beginners_mentor_images"
                />
              </div>
              <div className="mentor_para">
                <h3>Sogo Ogundowole</h3>
                <p>Senior Data Engineer</p>
              </div>
            </div>

            <div className="beginners_mentor_wraps">
              <div className="mentor_image_wrap">
                <img
                  src={toba}
                  alt="Toba"
                  className="beginners_mentor_images"
                />
              </div>
              <div className="mentor_para">
                <h3>Oluwatoba Adesugba</h3>
                <p>ML Engineer and Technical Writer</p>
              </div>
            </div>

            <div className="beginners_mentor_wraps">
              <div className="mentor_image_wrap">
                <img
                  src={eri}
                  alt="Eri"
                  className="beginners_mentor_images"
                />
              </div>
              <div className="mentor_para">
                <h3>Erioluwa Asiru</h3>
                <p>Backend Developer</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default IntermediateTrack;
